// User management service
import axios from 'axios';
import { User } from './AuthService';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

export interface CreateUserData {
  username: string;
  password: string;
  email: string;
  role?: string;
}

export interface UpdateUserData {
  email?: string;
  password?: string;
  role?: string;
}

class UserService {
  // Get all users (admin only)
  async getAllUsers(): Promise<User[]> {
    try {
      const response = await axios.get<User[]>(`${API_URL}/users`);
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        throw new Error(error.response.data.error || 'Fehler beim Abrufen der Benutzer');
      }
      throw new Error('Fehler beim Abrufen der Benutzer');
    }
  }

  // Get user by ID
  async getUserById(id: string): Promise<User> {
    try {
      const response = await axios.get<User>(`${API_URL}/users/${id}`);
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        throw new Error(error.response.data.error || 'Fehler beim Abrufen des Benutzers');
      }
      throw new Error('Fehler beim Abrufen des Benutzers');
    }
  }

  // Create a new user (admin only)
  async createUser(userData: CreateUserData): Promise<User> {
    try {
      const response = await axios.post<{ message: string; user: User }>(`${API_URL}/users`, userData);
      return response.data.user;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        throw new Error(error.response.data.error || 'Fehler beim Erstellen des Benutzers');
      }
      throw new Error('Fehler beim Erstellen des Benutzers');
    }
  }

  // Update a user
  async updateUser(id: string, userData: UpdateUserData): Promise<User> {
    try {
      const response = await axios.put<{ message: string; user: User }>(`${API_URL}/users/${id}`, userData);
      return response.data.user;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        throw new Error(error.response.data.error || 'Fehler beim Aktualisieren des Benutzers');
      }
      throw new Error('Fehler beim Aktualisieren des Benutzers');
    }
  }

  // Delete a user
  async deleteUser(id: string): Promise<boolean> {
    try {
      await axios.delete(`${API_URL}/users/${id}`);
      return true;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        throw new Error(error.response.data.error || 'Fehler beim Löschen des Benutzers');
      }
      throw new Error('Fehler beim Löschen des Benutzers');
    }
  }
}

export default new UserService();